import { render, staticRenderFns } from "./AppDistrict.vue?vue&type=template&id=3540c748&scoped=true&"
import script from "./AppDistrict.vue?vue&type=script&lang=js&"
export * from "./AppDistrict.vue?vue&type=script&lang=js&"
import style0 from "./AppDistrict.vue?vue&type=style&index=0&id=3540c748&prod&lang=scss&scoped=true&"
import style1 from "./AppDistrict.vue?vue&type=style&index=1&id=3540c748&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3540c748",
  null
  
)

export default component.exports